export default __webpack_public_path__ + "static/media/partner-all.6e121553.svg";